import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const freshbooks = defineConnector({
  identifier: "freshbooks",
  name: "FreshBooks",
  tagLine: "Cloud accounting software",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.freshbooks\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create a FreshBooks app",
      items: [
        {
          kind: "markdown",
          content:
            "Go to the [FreshBooks developer portal](https://my.freshbooks.com/#/developer) and click **Create an app**. Select the scopes your workflows need.",
        },
        {
          kind: "markdown",
          content: "Under **Redirect URIs**, add the following:",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/freshbooks/callback",
        },
      ],
    },
    {
      title: "Enter OAuth credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
          helperText: "From your app’s settings page in the developer portal.",
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Connect your FreshBooks account",
      items: [
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () => "https://auth.freshbooks.com/oauth/authorize/",
    tokenEndpoint: () => "https://api.freshbooks.com/auth/oauth/token",
    tokenEndpointAuthMethod: () => "client_secret_post",
    tokenRequestFormat: () => "json",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://api.freshbooks.com/auth/api/v1/users/me",
  },
});
